import gql from 'graphql-tag';

export const ShopFragmentCartEndpoint = gql`
  fragment ShopFragmentCartEndpoint on ShopModel {
    id
    identify
    opens_soon
    icon_list
    icon_map
    title
    type
    address
    ya_maps_url
    tips
    phone
    schedule {
      days
      hours
    }
    metroStations {
      id
      title
      line {
        id
        title
        color
      }
    }
    geo
    images {
      file_webp
      file
    }
  }
`;
